export default __webpack_public_path__ + "static/media/delete.e493cbe6.svg";